import * as constants from '@config/constants';

const initialState = {
  verify: '',
  key: '',
};

const reducer = (state = initialState, action) => {
  if (action.type !== constants.XHR_COMPLETE) {
    return state;
  }
  if (action.key.includes('ScreenConsoleKeyApi-key')) {
    return { ...state, ...action.payload };
  }
  return state;
};

export default reducer;
